import { styled, Alert as AlertMui } from '@mui/material';

export const Alert = styled(AlertMui)`
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  z-index: 5000;
`;
